var React = require('react');

function VolumeOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12,8c0-1.6-0.9-2.9-2.2-3.6v2L12,8.6C12,8.4,12,8.2,12,8z M14.2,8c0,0.8-0.2,1.6-0.5,2.3l1.3,1.3C15.7,10.6,16,9.3,16,8\n\tc0-3.8-2.7-7-6.2-7.8V2C12.3,2.8,14.2,5.2,14.2,8z M1.1,0L0,1.1l4.2,4.2H0v5.3h3.6L8,15.1v-6l3.8,3.8c-0.6,0.5-1.3,0.8-2,1v1.8\n\tc1.2-0.3,2.3-0.8,3.3-1.6l1.8,1.8l1.1-1.1l-8-8L1.1,0z M8,0.9L6.1,2.7L8,4.6V0.9z"}));
}

VolumeOff.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = VolumeOff;

VolumeOff.default = VolumeOff;
